import React, { RefObject } from 'react';

import cn from 'class-names';

import Input from '@uikit/Form/Input/Input';

import './NumberInput.css';
import { SVGIcon } from '@uikit/old/Icon/Icon';
import { Button } from '@uikit/Form/Button/Button';

export type NumberInputValueType = number | '';

type NumberInputType = {
  beforeText?: string;
  value: NumberInputValueType;
  maxNumber?: number;
  minNumber?: number;
  step?: number;
  onChange: (value: number | '') => void;
  inputRef?: RefObject<HTMLInputElement>;
  disabledArrows?: boolean;
  className?: string;
  isCustom?: boolean;
  beforeTextGray?: boolean;
  [key: string]: any;
};

const NumberInput = ({
  beforeText,
  value,
  maxNumber,
  minNumber,
  step = 1,
  onChange,
  inputRef,
  disabledArrows = false,
  className,
  isCustom = false,
  beforeTextGray = false,
  ...rest
}: NumberInputType): JSX.Element => {
  const cnNumberInput = cn('number-input', {
    'number-input--without-arrows': disabledArrows,
    [className]: !!className,
  });

  const cnCustomNumberInput = cn('number-input__custom-wrapper', {
    'number-input__disabled': disabledArrows || rest.disabled,
    'number-input__hide-arrows': isCustom,
  });

  return isCustom ? (
    <div className={cnCustomNumberInput}>
      {beforeText && (
        <span
          className={`number-input__before-text ${beforeTextGray ? 'number-input__before-text-gray' : ''}`}
        >
          {beforeText}
        </span>
      )}
      <Input
        placeholder=""
        className={cnNumberInput}
        inputRef={inputRef}
        type="number"
        value={value}
        onBlur={({ target: { value: val } }) => {
          if (Number.isNaN(Number(val)) || val < minNumber) {
            onChange(minNumber);
            return;
          }
        }}
        onChange={({ target: { value: val } }) => {
          if (val === '') {
            onChange('');
            return;
          }

          if (val > maxNumber) {
            onChange(maxNumber);
            return;
          }

          onChange(val);
        }}
        {...rest}
      />
      <div className="number-input__arrows">
        <Button
          className="number-input__button"
          onClick={() => {
            if (value !== '' && !disabledArrows && value + step <= maxNumber) {
              onChange(value + step);
            }
          }}
        >
          <SVGIcon
            icon="arrowDown"
            color="#C4C6CD"
            size={20}
            className="number-input__arrow-icon up-arrow"
          />
        </Button>
        <Button
          className="number-input__button"
          onClick={() => {
            if (value !== '' && !disabledArrows && value - step >= minNumber) {
              onChange(value - step);
            }
          }}
        >
          <SVGIcon
            icon="arrowDown"
            color="#C4C6CD"
            size={20}
            className="number-input__arrow-icon"
          />
        </Button>
      </div>
    </div>
  ) : (
    <div className="number-input-wrapper">
      {beforeText && (
        <span
          className={`number-input__before-text ${beforeTextGray ? 'number-input__before-text-gray' : ''}`}
        >
          {beforeText}
        </span>
      )}
      <Input
        placeholder=""
        className={cnNumberInput}
        inputRef={inputRef}
        type="number"
        value={value}
        step={step}
        onBlur={({ target: { value: val } }) => {
          if (Number.isNaN(Number(val)) || val < minNumber) {
            onChange(minNumber);
            return;
          }
        }}
        onChange={({ target: { value: val } }) => {
          if (val === '') {
            onChange('');
            return;
          }

          if (val > maxNumber) {
            onChange(maxNumber);
            return;
          }

          onChange(val);
        }}
        {...rest}
      />
    </div>
  );
};

export default NumberInput;
